import checkDesktopStyles from "./checkdesktop.module.css";

const checkDesktop = checkDesktopStyles.checkDesktop; //mobile and desktop
const checklistDesktop = checkDesktopStyles.checklistDesktop; //desktop

const CheckListDesktopData = [
  {
    id: 1,
    divClassName: checklistDesktop,
    imgClassName: checkDesktop,
    span: "get help with troubleshooting difficult cases and backlog with on-going office support and training",
  },

  {
    id: 2,
    divClassName: checklistDesktop,
    imgClassName: checkDesktop,
    span: "coordinators receive access to access boot camp advisors monday-friday 8:00 am to 8:00 pm EST ",
  },

  {
    id: 3,
    divClassName: checklistDesktop,
    imgClassName: checkDesktop,
    span: "office staff receive education on documentation and processing",
  },

  {
    id: 4,
    divClassName: checklistDesktop,
    imgClassName: checkDesktop,
    span: (
      <>
        <div>
          book a room and sharpen your skill set with priceless medical
          educational conferences. offered to both your office staff and
          coordinators
        </div>
        <br />
        <div>
          for coordinators who sign up get 50% off lodging
          <br />
          for office staff who sign up get 10% off lodging
        </div>
      </>
    ),
  },
  {
    id: 5,
    divClassName: checklistDesktop,
    imgClassName: checkDesktop,
    span: "receive monthly check ins with a 12 week follow up",
  },
  {
    id: 6,
    divClassName: checklistDesktop,
    imgClassName: checkDesktop,
    span: "receive one on one training for access to buy and bill specialists",
  },
  {
    id: 7,
    divClassName: checklistDesktop,
    imgClassName: checkDesktop,
    span: "receive training on the process of patient leave behinds",
  },
  {
    id: 8,
    divClassName: checklistDesktop,
    imgClassName: checkDesktop,
    span: "HIPAA compliant",
  },
  {
    id: 9,
    divClassName: checklistDesktop,
    imgClassName: checkDesktop,
    span: "ehr knowledge: EMA, e-clinicals, nextgen, epic",
  },
  {
    id: 10,
    divClassName: checklistDesktop,
    imgClassName: checkDesktop,
    span: "cover-my-med's",
  },
  {
    id: 11,
    divClassName: checklistDesktop,
    imgClassName: checkDesktop,
    span: "increase fill times",
  },
  {
    id: 12,
    divClassName: checklistDesktop,
    imgClassName: checkDesktop,
    span: "copay card enrollments",
  },
  {
    id: 13,
    divClassName: checklistDesktop,
    imgClassName: checkDesktop,
    span: "hub service enrollments",
  },
  {
    id: 14,
    divClassName: checklistDesktop,
    imgClassName: checkDesktop,
    span: "live excel spreadsheet tracking",
  },
];

export default CheckListDesktopData;
